<template>
  <v-tabs
    v-model="tab"
    center-active
    color="success"
  >    
    <v-tab
      v-for="item in items"
      :key="item.value"
    >
      {{ item.label }}
    </v-tab>
    <v-tab-item
      v-for="item in items"
      :key="item.value"
    >      
      <component
        :is="item.componentName"
        v-if="order"        
        :order="order"
        @event="onEvents"
      />
    </v-tab-item>
  </v-tabs>
</template>

<script>
  import { mapActions } from 'vuex';
  
  import OrderDetailTabDocuments from './OrderDetailTabDocuments.vue';
  import OrderDetailTabTrackings from './OrderDetailTabTrakings.vue';
  import OrderDetailTabPayments from './OrderDetailTabPayments.vue';
  import AutovistoriaForm from '../autovistoria/FormAutovistoria.vue';

  export default {
    name: 'OrderDetailTabs',
  
    components: {
      OrderDetailTabDocuments,
      OrderDetailTabTrackings,
      OrderDetailTabPayments,
      AutovistoriaForm
    },

    props: {
      order: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      tab: null,
      items: []
    }),

    mounted() {
      this.buildItems();
    },

    watch: {
      order: {
        deep: true,
        handler() {
          this.buildItems();
        }
      }
    },

    methods: {
      buildItems() {
        this.items = [
          { label: 'Documentos', value: 'documents', componentName: 'OrderDetailTabDocuments' },
          { label: 'Acompanhamentos', value: 'trackings', componentName: 'OrderDetailTabTrackings' },
          { label: 'Pagamentos', value: 'payments', componentName: 'OrderDetailTabPayments' }
        ]        

        if (this.order.inspectable) {
          this.items.push({ label: 'Autovistoria', value: 'autovistoria', componentName: 'AutovistoriaForm' });
        }
      },

      onEvents() {              
        this.fetchOrder();
        this.buildItems();
      },

      fetchOrder() {        
        if (!this.$route.params.id) return;

        this.fetch(this.$route.params.id);
      },

      ...mapActions('pedido', { 
        fetch: 'SHOW' 
      })
    }
  };
</script>

<style lang="scss" scoped>
.v-tab.v-tab--active {  
  color: #212121 !important;
}
</style>